import { ReactElement } from 'react';

// Components.
import { Chart } from 'components/Chart';
import { DashboardSection } from '../DashboardSection';

// Types.
import { IDashboardChartSection } from 'store/dashboard/types';

export const DashboardChartSection = (props: IDashboardChartSection): ReactElement => {
  const { chartData, label, toggleable } = props;

  return (
    <DashboardSection label={label} toggleable={toggleable}>
      <Chart options={chartData} />
    </DashboardSection>
  );
};
